import React from 'react';
import { useCreateProduct } from './presenter';
import { ProductCreateView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const ProductCreatePage: React.FC<Props> = ({ navigate }) => {
  const vm = useCreateProduct(() => navigate({ name: 'products/index' }));
  const confirm = useConfirm();
  const toast = useToast();
  return (
    <ProductCreateView
      form={vm.form}
      setField={vm.setField as any}
      setImageFile={vm.setImageFile}
      onSubmit={async () => {
        const ok = await confirm({ title: 'Save Product', message: 'Create this product?', confirmText: 'Save' });
        if (!ok) return;
        await vm.submit();
        toast.success('Product created');
      }}
      onCancel={() => navigate({ name: 'products/index' as any })}
      loading={vm.loading}
      error={vm.error}
    />
  );
};

export default ProductCreatePage;
